export const Sorting = {
  CREATED: "created",
  MODIFIED: "modified",
  TITLE: "title",
};

export const Ordering = {
  ASCENDING: "ascending",
  DESCENDING: "descending",
};

export const CurrentSpaceOption = {
  icon: undefined,
  name: "Current Space",
  spaceKey: "current-space-hardcoded",
  type: "space",
  label: "Current Space",
  value: "current-space-hardcoded",
  homepageId: "undefined",
  coverPictureCallback: async () => {},
};
export const CurrentPageOption = {
  contentId: "current-page-hardcoded",
  type: "page",
  name: "Current Page",
  space: undefined,
  excerpt: "",
  url: undefined,
  createdBy: undefined,
  lastModified: undefined,
  label: "Current Page",
  value: "current-page-hardcoded",
};

export async function searchSpaces({ queryKey, pageParam = undefined }) {
  const [
    _key,
    {
      categories = [],
      spaceType = "global",
      spaceStatus = "current",
      limit = 2,
    },
  ] = queryKey;
  // space issue here
  const labelsSplitted = categories.join(",");
  let url = `/api/v2/spaces?type=${spaceType}&status=${spaceStatus}&limit=${limit}&include-icon=true&description-format=plain`;

  if (labelsSplitted.length > 0) {
    url = `${url}&labels=${labelsSplitted}`;
  }

  if (pageParam) {
    url = `${url}&cursor=${pageParam}`;
  }

  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch spaces");
    console.log(e);
  }
}

export async function getSpaceByKey(spaceKey) {
  try {
    return window.AP.request(
      `/api/v2/spaces?keys=${spaceKey}&include-icon=true&description-format=plain`
    );
  } catch (error) {
    return undefined;
  }
}

export async function getSpacesByKey(spaceKeys) {
  try {
    return window.AP.request(
      `/api/v2/spaces?keys=${spaceKeys.join(
        ","
      )}&include-icon=true&description-format=plain`
    );
  } catch (error) {
    return undefined;
  }
}

export const getAdminUsers = (permissions) =>
  permissions
    .filter((p) => p?.subjects?.user)
    .map((p) => {
      const users = p.subjects.user?.results
        ?.filter((u) => u.accountType === "atlassian")
        .map((u) => ({
          id: u.accountId,
          key: u.accountId,
          name: u.displayName,
          icon: u.profilePicture?.path
            ? `${window.AP._hostOrigin}${u.profilePicture.path}`
            : "",
        }));

      return users;
    })
    .flat();

export const getAdminGroups = (permissions) =>
  permissions
    .filter((p) => p?.subjects?.group)
    .map((p) => {
      const groups = p.subjects.group?.results?.map((g) => ({
        groupId: g.id,
        name: g.name,
      }));

      return groups;
    })
    .flat()
    .filter(
      (value, index, self) => index === self.findIndex((t) => t.id === value.id)
    );

async function getUsersFromGroup(groupId) {
  const url = `/rest/api/group/${groupId}/membersByGroupId`;
  try {
    return window.AP.request(url);
  } catch (error) {
    console.log("can't fetch group members");
    console.log(error);
  }
}

export async function getUsersForArrayOfGroups(groups) {
  try {
    return Promise.all(
      groups.map((g) => {
        return new Promise(async (resolve) => {
          try {
            const response = await getUsersFromGroup(g.groupId);
            if (response.body) {
              const data = JSON.parse(response.body);
              const users = data?.results?.map((u) => ({
                id: u.accountId,
                key: u.accountId,
                name: u.displayName,
                icon: u.profilePicture?.path
                  ? `${window.AP._hostOrigin}${u.profilePicture.path}`
                  : "",
              }));

              if (users) {
                resolve(users);
              } else {
                resolve([]);
              }
            }

            resolve([]);
          } catch (error) {
            console.error(error?.message);
            resolve([]);
          }
        });
      })
    );
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function getCurrentUserSpaceWatchStatus(spaceKey) {
  const url = `/rest/api/user/watch/space/${spaceKey}`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch watch status");
    console.log(e);
  }
}
